import Box from "@ui-kit/layout/Box/Box.web";
import TicketQuantityPrompt from "@shared/modules/events/components/calendar/TicketQuantityPrompt/TicketQuantityPrompt.web";
import { WizardStep } from "@shared/components/application/navigation/Wizard/WizardStep.web";
import { useTranslation } from "@shared/utils/internationalization";
import { useEffect } from "react";
import { AnalyticsService } from "@shared/services/analytics";
import { enums } from "@shared/constants";
import { EVENT_WIZARD_SCREENS_MAP } from "../types";
import { TicketQuantityPromptScreenProps } from "./TicketQuantityPromptScreen.props";

function TicketQuantityPromptScreen({
  onSuccessAction,
  isLoading = false,
  event,
}: TicketQuantityPromptScreenProps) {
  const { t } = useTranslation("common");

  useEffect(() => {
    AnalyticsService.eventViewed(event, {
      label: enums.INTERACTION_LABEL_MAP.EVENT_CALENDAR_QUANTITY_PROMPT.id,
    });
  }, [event]);

  return (
    <WizardStep
      stepId={EVENT_WIZARD_SCREENS_MAP.TICKET_QUANTITY_PROMPT.id}
      stepName={t("Ticket Quantity")}
    >
      {!isLoading && (
        <Box
          padding={{
            base: "0 24px",
            xs: "xl",
          }}
        >
          <TicketQuantityPrompt onQuantitySelect={onSuccessAction} />
        </Box>
      )}
    </WizardStep>
  );
}

export default TicketQuantityPromptScreen;
